var hero_title = document.querySelector('.hero-title');
var hero_subtitle = document.querySelector('.hero-subtitle');

var taglines = [
    {
        name: "Design",
        text: [
            "User-centric, simple, intuitive, results driven."
        ]
    },
    {
        name: "Development",
        text: [
            "Think long term, code responsibly, focus on the user."
        ]
    },
    {
        name: "Cloud Services",
        text: [
            "Security, stability, scalability."
        ]
    }
]

var tagline = taglines[0];

typeTagline(tagline);

function typeTagline(tagline) {
    var title_character = 0;

    hero_title.textContent = '';
    hero_subtitle.textContent = '';

    var title_interval = setInterval(function() {
        hero_title.textContent += tagline['name'][title_character];
        title_character++;
        hero_subtitle.textContent = tagline['text'][0];

        hero_subtitle.classList.add('active');

        if (title_character > tagline['name'].length - 1) {
            clearInterval(title_interval);

            setTimeout(function() {
                eraseTagline();
            }, 3000)
        }
    }, 120);
}

function eraseTagline() {
    hero_subtitle.classList.remove('active');

    var title_interval = setInterval(function() {
        hero_title.textContent = hero_title.textContent.slice(0, hero_title.textContent.length - 1);

        if (!hero_title.textContent) {
            clearInterval(title_interval);

            setTimeout(function() {
                var random = taglines[Math.floor(Math.random() * taglines.length)];

                while (random == tagline) {
                    random = taglines[Math.floor(Math.random() * taglines.length)];
                }

                tagline = random;

                typeTagline(tagline);
            }, 500);
        }
    }, 80);
}